import { useBetslipStore } from '@/store/betslip';
import { ParlayTicketModel } from '@/hooks/query';

// 是否顯示header alert
export const useAlertBetslip = (isIndependentMode: boolean) => {
	const [
		currentParlayTicketModel,
		canBetResult,
		betslipTab,
		betslipType,
		currentMultiTickets
	] = useBetslipStore(state => [
		state.currentParlayTicketModel,
		state.canBetResult,
		state.betslipTab,
		state.betslipType,
		state.currentMultiTickets,
	]);

	const isIndependentParlayLayout = isIndependentMode && betslipTab === 'parlay';

	const hasInvalidComboData = (comboData?: ParlayTicketModel[]) =>
		!comboData || comboData.length === 0 || comboData.some(ticket => !ticket.CanBet);

	const showAlert = currentMultiTickets.length > 0 && isIndependentParlayLayout && betslipType === 'multi'
		? hasInvalidComboData(currentParlayTicketModel?.comboData)
		: canBetResult.innerMsg.some(data => !data.canBet);
	
	return {
		showAlert
	}
}